
import React from 'react';
import { MapPin, Users } from 'lucide-react';
import { Company } from '@/lib/types';
import CompanyPerks from '../CompanyPerks';

interface CompanyBasicInfoProps {
  company: Company | null;
  companyName: string;
  locations: string[];
}

const CompanyBasicInfo: React.FC<CompanyBasicInfoProps> = ({
  company,
  companyName,
  locations
}) => {
  // Get only the primary location from the company data
  const primaryLocation = company?.locations && company.locations.length > 0 
    ? company.locations[0] 
    : locations.length > 0 ? locations[0] : null;

  return (
    <div className="flex flex-wrap items-start gap-4 mb-4">
      {company?.logo && (
        <img 
          src={company.logo} 
          alt={`${companyName} logo`} 
          className="h-16 w-16 object-contain"
        />
      )}
      <div className="flex-1">
        <h1 className="text-3xl font-bold text-redflags-dark mb-1">{companyName}</h1>
        
        {/* Only show the primary location */}
        {primaryLocation && (
          <div className="flex flex-wrap gap-2 text-sm text-redflags-gray mb-2">
            <div className="flex items-center">
              <MapPin className="h-4 w-4 mr-1" />
              {primaryLocation}
            </div>
          </div>
        )}
        
        {/* Employee count badge */}
        {company?.staffSize && (
          <div className="flex items-center gap-1 mb-3 text-sm text-redflags-gray">
            <Users className="h-4 w-4" />
            <span>{company.staffSize} employees</span>
          </div>
        )}
        
        {/* Company Perks button */}
        {company && (
          <CompanyPerks companyId={company.id} companyName={companyName} />
        )}
      </div>
    </div>
  );
};

export default CompanyBasicInfo;
